import { EventParentalControlRating } from 'services/data-manager/types';

import getParentalRatingNumber from 'components/ContentMarkerIcons/utils/getParentalRatingNumber';

export enum ContentMarkerType {
    PARENTAL_RATING = 'PARENTAL_RATING',
    CATCHUP = 'CATCHUP',
    STARTOVER = 'STARTOVER',
}

type Props = {
    parentalRating?: number | EventParentalControlRating;
    shouldDisplayCatchup?: boolean;
    shouldDisplayStartOver?: boolean;
};

export default function getMostSpecificIconType({
    parentalRating,
    shouldDisplayCatchup,
    shouldDisplayStartOver,
}: Props): ContentMarkerType | null {
    const parentalRatingNumber = getParentalRatingNumber(parentalRating);

    if (parentalRatingNumber !== undefined) {
        return ContentMarkerType.PARENTAL_RATING;
    }

    if (shouldDisplayCatchup) {
        return ContentMarkerType.CATCHUP;
    }

    if (shouldDisplayStartOver) {
        return ContentMarkerType.STARTOVER;
    }

    return null;
}
